import React from "react";
import { PackageOpen, PackageSearch, RefreshCw, SearchX } from "lucide-react";

const CommerceEmptyState = ({ title, description, hasActiveFilters, onClearFilters, onRefresh }) => (
  <div className="flex flex-col items-center justify-center px-6 py-16 text-center sm:py-20">
    <div className="relative mb-6">
      <div className="absolute inset-0 bg-[#FF6C6C]/10 rounded-full blur-2xl scale-150" />
      <div className="relative flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#FF6C6C]/10 to-pink-100 rounded-2xl border border-[#FF6C6C]/20">
        {hasActiveFilters ? (
          <SearchX className="w-9 h-9 text-[#FF6C6C]" />
        ) : (
          <PackageOpen className="w-9 h-9 text-[#FF6C6C]" />
        )}
      </div>
      {!hasActiveFilters && (
        <PackageSearch className="absolute -bottom-1 -right-1 w-7 h-7 text-gray-400 bg-white rounded-full p-1 shadow-sm border border-gray-100" />
      )}
    </div>

    <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
    <p className="mt-2 max-w-sm text-sm text-gray-500">{description}</p>

    <div className="flex gap-3 items-center mt-6">
      {hasActiveFilters && (
        <button
          type="button"
          onClick={onClearFilters}
          className="px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-xl hover:bg-gray-200 transition-colors"
        >
          Clear Filters
        </button>
      )}
      <button
        type="button"
        onClick={onRefresh}
        className="inline-flex gap-2 items-center px-4 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-[#FF6C6C] to-[#FF8F8F] rounded-xl shadow-sm hover:opacity-90 transition-all"
      >
        <RefreshCw className="w-4 h-4" />
        Refresh
      </button>
    </div>
  </div>
);

export default CommerceEmptyState;
